import { HelpCircle } from 'lucide-react';
import { Tooltip } from '../../../../components/ui/tooltip';

interface ColumnHeaderHelpProps {
  label: string;
  help: string;
  className?: string;
  iconOnly?: boolean;
}

export const ColumnHeaderHelp = ({
  label,
  help,
  className = '',
  iconOnly = false,
}: ColumnHeaderHelpProps) => (
  <span className={`inline-flex items-center gap-1 ${className}`}>
    {!iconOnly && <span>{label}</span>}
    <Tooltip
      content={
        <p className="max-w-xs text-xs leading-relaxed text-text-grey">{help}</p>
      }
      placement="top"
      usePortal
      contentClassName="rounded-lg border border-[#E2E5EA] bg-white px-3 py-2 shadow-md"
    >
      <button
        type="button"
        className="inline-flex text-heritage-grey hover:text-blueprint-blue focus:outline-none"
        aria-label={`Help: ${label}`}
      >
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
    </Tooltip>
  </span>
);
